import React from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';

import { DEFAULT_PAPER_ELEVATION, } from 'common/constants';
import SvgIcon from 'common/components/SvgIcon';
import infoIcon from 'assets/icons/icon_info.svg';

const ProductInfoBar = () => (
    <Paper elevation={DEFAULT_PAPER_ELEVATION}>
        <Box py={2}
             pr={2}>
            <Grid container>
                <Grid item
                      xs={2}
                      sm={1}
                      container
                      justify="center"
                      alignItems="center">
                    <SvgIcon src={infoIcon}
                             height={30} />
                </Grid>
                <Grid item
                      xs={10}
                      sm={11}
                      container
                      direction="column">
                    <Grid item>
                        <strong>Oferta dostępna wyłącznie dla szkół</strong>
                    </Grid>
                    <Grid item>
                        <Box mt={{ xs: 1, sm: 0, }}>
                            <Typography variant="caption">
                                Podane ceny są cenami brutto.
                            </Typography>
                        </Box>
                    </Grid>
                </Grid>
            </Grid>
        </Box>
    </Paper>
);

export default ProductInfoBar;
